export default "<div [id]=\"designerId\" class=\"reportContainer\"></div>\r\n"